/** Milliseconds until a support session ends (0 once it has). */
export function msUntilExpiry(expiresAt: string, now: Date): number {
  const end = Date.parse(expiresAt);
  return Number.isNaN(end) ? 0 : Math.max(0, end - now.getTime());
}

/** A support reason is usable once it says something (the server requires the same 5 characters). */
export const MIN_SUPPORT_REASON = 5;

export function supportReasonProblem(reason: string): string | null {
  return reason.trim().length >= MIN_SUPPORT_REASON ? null : "Say why you need to look (at least 5 characters).";
}
